// Safe replacement for `window.open(url, "_blank")`.
//
// - Only http(s) and blob: URLs are opened, so a `javascript:`/`data:` URL
//   coming from an API response (doc_url, file_path, ...) can never execute.
//   blob: is allowed because our own page creates it (URL.createObjectURL for
//   freshly selected files) and it inherits our origin.
// - Cross-origin targets are opened with `noopener,noreferrer`, so the new
//   page cannot reach back through `window.opener` or see our URL as Referer.
// - Same-origin targets (our own detail pages) are opened normally: they are
//   trusted, and `noopener` would stop the browser from copying
//   `sessionStorage` (list filters) into the new tab.
export const openInNewTab = (url) => {
  if (!url) return null;

  let target;
  try {
    target = new URL(String(url), window.location.href);
  } catch {
    return null;
  }

  const allowedProtocols = ["http:", "https:", "blob:"];
  if (!allowedProtocols.includes(target.protocol)) {
    return null;
  }

  if (target.origin === window.location.origin) {
    return window.open(target.href, "_blank");
  }

  return window.open(target.href, "_blank", "noopener,noreferrer");
};

export default openInNewTab;
